import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterRadioInputBoxHandler from "./IDataFilterRadioInputBoxHandler";
import IDataFilterRadioInputValue from "./IDataFilterRadioInputValue";

export default class DataFilterRadioInputBoxHandler
  implements IDataFilterRadioInputBoxHandler {
  setDescriptorValuesFromUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    (descriptor.value as IDataFilterRadioInputValue).value =
      urlParams.get(descriptor.name) ?? "";
  }

  setDescriptorValuesToUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ): void {
    const radioBoxValue = descriptor.value as IDataFilterRadioInputValue;
    if (radioBoxValue) {
      urlParams.set(descriptor.name, radioBoxValue.value);
    } else {
      urlParams.delete(descriptor.name);
    }
  }
}
